import { createFileRoute } from "@tanstack/react-router";

import { APP_ROUTERS } from "@/constants/app-routers";
import { MEMBER_SEARCH_ACTION } from "@/features/my/global-search";
import { MaskRedirect } from "@/features/shared/route-masking";

/**
 * Deep-link shim for the member search palette. The palette is a shell-level
 * overlay (mounted by `MyPlaceLayout`), not a page, so a reload or a pasted
 * `/my/global-search` lands on Home with `?action=global-search`, masked back
 * to this clean path. `/my/home` declares no `validateSearch`, so `action`
 * survives the redirect.
 */
function MemberGlobalSearchRedirect() {
  return (
    <MaskRedirect
      to={APP_ROUTERS.MY_HOME}
      action={MEMBER_SEARCH_ACTION}
      mask={APP_ROUTERS.MY_GLOBAL_SEARCH}
    />
  );
}

export const Route = createFileRoute("/(member)/(protected)/my/global-search")({
  component: MemberGlobalSearchRedirect,
});
